import { Component, type ReactNode } from 'react';

interface Props {
  children: ReactNode;
}
interface State {
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: { componentStack: string }) {
    console.error('Erro não tratado na interface:', error, info.componentStack);
  }

  render() {
    if (this.state.error) {
      return (
        <div className="login-wrap">
          <div className="card login-card" style={{ maxWidth: 460, textAlign: 'left' }}>
            <h2 style={{ color: 'var(--coral)' }}>Algo deu errado</h2>
            <p className="hint">A tela travou por causa de um erro inesperado. Tente recarregar a página. Se o problema continuar, avise o gestor com a mensagem abaixo.</p>
            <div className="doc-text mono" style={{ fontSize: 12 }}>{this.state.error.message}</div>
            <button className="btn btn-primary btn-block" style={{ marginTop: 14 }} onClick={() => window.location.reload()}>Recarregar</button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
